import React, { useCallback, useContext } from 'react'
import { HeaderNoNav } from '@grammarly/website-components'
import { useRouter } from 'next/dist/client/router'
import { PageContext } from '../../../../contexts/page-context'
import { useBrowserService, useUserService } from '../../../../lib/hooks'
import { EventProps, gnarClient } from '../../../../lib/tracking/gnar'
import { getConfig } from '../../../../config'
import { extractUtmParams } from '../../../../lib/utils/url'

const baseDomain = getConfig().domains.main
const shBaseDomain = getConfig().domains.superhuman

interface HeaderNoNavigationProps {
  ctas?: React.ReactNode
  secondaryHeader?: React.ReactNode
}

export const HeaderNoNavigation: React.FC<HeaderNoNavigationProps> = (props) => {
  const { pageId, slug } = useContext(PageContext)
  const { isAnonymous } = useUserService().currentUser
  const { isMobileOrTablet } = useBrowserService()

  const gnarTrackFn = useCallback(
    (trackEventProps: EventProps) => {
      return gnarClient.track({ ...trackEventProps, pageId, pageSlug: slug })
    },
    [pageId, slug]
  )

  const { query } = useRouter()
  const utmQueryParams = extractUtmParams(query)

  return (
    <HeaderNoNav
      clientName="cms"
      baseDomain={baseDomain}
      shBaseDomain={shBaseDomain}
      gnarTrackFn={gnarTrackFn}
      isLoggedIn={!isAnonymous}
      isMobileTablet={isMobileOrTablet}
      ctas={props.ctas}
      sticky
      queryParams={{ utmParams: utmQueryParams }}
    />
  )
}
